import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Observable, catchError, of, throwError } from 'rxjs';
import { environment } from 'src/environments/environment.development';
import { Media } from '../entities/media';
import { isPlatformBrowser } from '@angular/common';

interface ApiResponse {
  status: string;
  data: Media[];
}

interface ApiResponseDelete {
  status: string;
  data: { [key: string]: string };
}

@Injectable({
  providedIn: 'root'
})
export class MediaService {

  constructor(private http: HttpClient, @Inject(PLATFORM_ID) private platformId: Object) { }

  private apiServicesUrl = environment.cfgApiBaseUrl;
  private mediaServiceUrl = this.apiServicesUrl + '/media';

  saveMediaBulk(media: Media[]): Observable<ApiResponse> {
    const httpHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    }
    return this.http.post<ApiResponse>(this.mediaServiceUrl + '-bulk', media, httpHeaders)
    .pipe(
      catchError(this.handleError<ApiResponse>('getMedia'))
    );
  }

  getMediaByPerson(urlId: string): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(this.mediaServiceUrl + '/profile/' + urlId);
  }

  setAsProfile(fileName: string, url_id: string | undefined) {
    const httpHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    }
    return this.http.put<ApiResponseDelete>(this.mediaServiceUrl, { 'fileName': fileName, 'url_id': url_id }, httpHeaders)
    .pipe(
      catchError(this.handleError<ApiResponseDelete>('getMedia'))
    );
  }

  deleteImage(fileName: string, url_id: string | undefined) {
    let token;
    if (isPlatformBrowser(this.platformId))
      token = sessionStorage.getItem('auth');
    const httpHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'bearer ' + token
      }),
      body: {
        'fileName': fileName, 
        'url_id': url_id 
      }
    }
    return this.http.delete<ApiResponseDelete>(this.mediaServiceUrl, httpHeaders)
    .pipe(
      catchError(err => { return throwError(() => err) })
    );
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
  
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead
  
      // TODO: better job of transforming error for user consumption
      //this.log(`${operation} failed: ${error.message}`);
  
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}
